// API endpoints and constants

export const ENDPOINTS = {
  // Auth endpoints
  AUTH: {
    REGISTER: "/auth/register",
    REGISTER_GOOGLE: "/auth/register/google",
    LOGIN: "/auth/login",
    LOGIN_GOOGLE: "/auth/login/google",
    REFRESH: "/auth/refresh",
    SEND_VERIFICATION: "/auth/send/verification",
    VERIFY_CODE: "/auth/code/verify",
    FORGOT_PASSWORD: "/auth/forgot",
    RESET_PASSWORD: "/auth/change",
    GET_USER_INFO: "/v1/profile/get-ip/",
    POST_USER_INFO: "/users/country",
  },

  // User endpoints
  USER: {
    UPDATE_TYPE: "/users/user-type",
  },

  // Chat endpoints
  CHAT: {
    AGENTS: "/v1/agents",
    MULTIMODAL: "/v1/agents/multimodal",
    STREAM: "/v1/agents/stream/",
    STREAM_STATE: "/v1/agents/stream/state",
    ADMIN_AGENTS: "/v1/agents/admin",
    ADMIN_MULTIMODAL: "/v1/agents/admin/multimodal",
    CHATS: "/v1/chats",
  },

  // Shipment endpoints
  SHIPMENTS: {
    BY_CHAT: "/v1/shipments/by-chat",
    LIST: "/v1/shipments",
    BY_ID: "/api/v1/trucking/listings",
  },

  TRACKING: {
    ACTIVE: "/v1/shipments/active",
    TRACKED_HISTORY: "/v1/shipments/tracked-history",
    STREAM: "/v1/agents/tracking/stream",
    BOL_UPLOAD: "/v1/tracking/bol/upload",
  },

  // Port endpoints
  PORTS: {
    RECOMMEND: "/v1/ports/recommend",
  },

  DOCUMENTS: {
    LIST: "/documents/list-documents/",
    LISTINGS: "/documents/list-listings-with-documents/",
    AWAITING: "/documents/awaiting-documents",
  },

  // Blog endpoints
  BLOG: {
    GET_POSTS: "/blog/get-posts",
    GET_POST: "/blog/get-post",
    GET_CATEGORIES: "/blog/get-categories",
  },

  /** Trucking payment — paths appended to AUTH_BASE_URL origin (e.g. https://dev.dockie.ai) */
  PAYMENT: {
    PAYMENT_PROVIDER: "/api/v1/trucking/payment-provider/",
    PAYMENT_QUOTE: "/api/v1/trucking/payment-quote/",
    STRIPE_CHECKOUT_SESSION: "/api/v1/trucking/stripe/checkout-session/",
    PAYMENT_STATUS: "/api/v1/trucking/payment-status",
    LOG_PAYMENT_INIT: "/api/v1/trucking/log-payment-init/",
    VERIFY_TRUCKING_PAYMENT: "/api/v1/trucking/verify-payment",
    VERIFY_PAYSTACK_PAYMENT: "/transactions/verify",
  },
};

export const USER_TYPES = {
  RETAILER: 'retailer',
  DEALER: 'dealer',
};

export const STORAGE_KEYS = {
  AUTH_TOKEN: 'dockporter_token',
  CHAT_MESSAGES: 'dockie_chat_messages',
  /** @deprecated single global draft — use CHAT_INPUT_DRAFTS */
  CHAT_INPUT_DRAFT: 'chat-input-draft',
  CHAT_INPUT_DRAFTS: 'dockie_chat_input_drafts',
  AUTH_REDIRECT_URL: 'auth_redirect_url',
  AUTH_SESSION_ID: 'auth_session_id',
  AUTH_PENDING_ACTION: 'auth_pending_action',
};